<script setup lang="ts">
import AccountCardSmall from '@/onenetwork/components/account_card/AccountCardSmall.vue';
import { numHelper } from '@/utils/numHelper.ts';
import { computed } from 'vue';
import TagCell from './TagCell.vue';

interface Props {
  data: object | string | number,
  cellConfig: Object,
  tableConfig?: Object,
}

const props = defineProps<Props>()

const data: any = computed(() => props.data as object)

</script>

<template>
  <div class="flash-offer-item flex gap-3">
    <div class="flash-offer-item__info" v-if="data?.id">
      <div class="flash-offer-item__info-acc flex-col">
        <div class="flex flex-col gap-[3px]">
          <div class="flex text-[11px]">
            <div class="flex-1">
              <div class="bid-id">BID-{{ data?.id }}</div>
            </div>
            <div class="flex-1"></div>
          </div>
          <div class="flex text-[11px]">
            <div class="flex-1">Thời gian chốt deal:</div>
            <div class="flex-1">{{ data?.time }}</div>
          </div>
          <div class="flex">
            <div class="flex-1">Giá thoả thuận:</div>
            <div class="flex-1 font-bold">{{ numHelper(data?.deal_price).format() }} <sup>đ</sup></div>
          </div>
        </div>
        <div class="flex gap-2">
          <account-card-small :data="data.owner" class="customer" account-type="customer"/>
          <account-card-small :data="data.broker" account-type="broker"/>
        </div>

      </div>
    </div>
    <div class="flash-offer-item__info" v-else>
      <div class="flash-offer-item__info-acc flex-col">
        <div class="flex flex-col gap-[3px]">
          <div class="flex justify-center text-[11px]">

            <TagCell :data="data.status" :cellConfig="{}" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
